<template>
  <div class="input-group">
    <div class="dropdown">
      <div class="selected"
        @click="handleOpen"
        ref="button"
        :class="{'is-open': showItems}" v-text="selected.length > 22 ? selected.substring(0, 22) + '...' : selected"></div>
      <ul class="items"
        v-closable="{ exclude: ['button'], handler: 'handleClose' }"
        v-if="showItems">
        <li v-for="(item, index) in items" :key="index" :class="{'is-active': item === selected}">
          <a href="#" @click.prevent="$emit('changed', index); showItems = false" v-text="item"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['selected', 'items'],
  data () {
    return {
      showItems: false
    }
  },
  methods: {
    handleOpen () {
      if (!this.showItems) {
        this.$root.$emit('dropdownOpened')
        this.showItems = true
      } else {
        this.showItems = false
      }
    },
    handleClose () {
      this.showItems = false
    }
  },
  mounted () {
    this.$root.$on('dropdownOpened', () => {
      this.showItems = false
    })
  }
}
</script>

<style lang="scss">
  .dropdown {
    width: 100%;
    position: relative;

    .selected {
      position: relative;
      background: $color-medium-green;
      border-radius: 3px;
      color: $color-white;
      font-size: 24px;
      font-weight: 400;
      text-align: left;
      padding: 12px 20px;

      &:hover {
        cursor: pointer;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        width: 12px;
        height: 17px;
        background: url('/assets/dropdown-arrow.svg') no-repeat center center;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.2s ease-in-out;
      }
      &.is-open {

        &:after {
          transform: rotate(180deg);
          transform-origin: 50% 20%;
        }
      }
    }
    .items {
      background: $color-dark-white;
      box-shadow: 0px 20px 20px rgba(59, 68, 6, 0.45);
      border-radius: 3px;
      text-align: left;
      padding: 20px 0;
      position: absolute;
      top: 78px;
      left: 0;
      width: 100%;
      z-index: 99;
      margin: 0;
      list-style: none;
      li {
        list-style: none;
        padding: 0 0 0 20px;
        margin: 0;
        color: $color-black;
        &.confirmation{
          background: rgba($color-red,.2);
          a{
            display: inline-block;
            text-align: center;
            padding-left: 10px;
            &:hover{
              color: $color-red;
            }
          }
        }
        a {
          display: block;
          font-size: 16px;
          line-height: 20px;
          padding: 8px 12px;
          font-weight: 600;
          color: $color-black;
          border-radius: 3px 0 0 3px;
          text-decoration: none;
          transition: all 0.2s ease-in-out;

          &:hover {
            color: $color-green;
          }
        }
        &.is-active {
          a {
            background: $color-green;
            color: $color-white;

            &:hover {
              color: $color-white;
            }
          }
        }
      }
    }
  }
</style>
